"use client";

import React from "react";

import { ANNUAL_MULTI_TRIP } from "@/constants";

import { useTravelDatesContext } from "../../providers/travel-dates.provider";
import Styles from "../../travel-date-answer-page.module.css";
import DateRangePickerComponent from "../date-range-picker";
import SingleDatePickerComponent from "../single-date-picker";
import ValidationModal from "../validation-modal";

export default function FormContent() {
  const { groupedMagnoliaData, keyForGroupedMagnolia, quotePolicyType } =
    useTravelDatesContext();

  const title = groupedMagnoliaData?.[keyForGroupedMagnolia]?.headerText ?? "";

  if (!quotePolicyType) return null;

  return (
    <div className="w-full flex justify-center">
      <div className="lg:w-[414px] md:w-[400px] w-full ">
        <ValidationModal />
        <h1 className="font-header-font lg:text-[39px] md:text-3xl text-[26px] lg:leading-[44.85px] md:leading-[34.1px] leading-[29.9px] text-text-title md:text-left text-center">
          {title}
        </h1>
        <div
          data-testid="travel-date-answer-page-test-id"
          className={`${Styles.date_picker_wrapper} flex flex-col gap-x-2 md:mt-spacing-l mt-spacing-m w-full relative `}
        >
          {quotePolicyType === ANNUAL_MULTI_TRIP ? (
            <SingleDatePickerComponent />
          ) : (
            <DateRangePickerComponent />
          )}
        </div>
      </div>
    </div>
  );
}
